import AppRouter from './AppRouter';
import React from 'react';
import { BrowserRouter, Link } from 'react-router-dom';
import './App.scss';

const App = () => {
  const header = React.useRef()

  return (
    <BrowserRouter>
      <div className="App">
        <div className="navBar">
          <div id="navContents">
            <Link to="/" id="main">
              <div id="name">
                <h1>Chae</h1>
                <h1>Ryeong</h1>
                <h1>Oh</h1>
              </div>
            </Link>
            <div id="nav">
              <p>&#123;</p>
              <div id="navbuttons">
                <Link to="/about" id="workref">
                  About
                </Link>
                <Link to="/works" id="workref">
                  Works
                </Link>
              </div>
              <p>&#125;</p>
            </div>
          </div>
        </div>


        <AppRouter header={header} />

        <div className="footer">2024, by Chaeryeong Oh. All rights reserved.</div>
      </div>
    </BrowserRouter>

  );
};

export default App;
